import type { ReactNode } from 'react';
import { HjelperammeProvider } from '../context/HjelperammeContext';
import { Nettstedsbunn, Nettstedstopp } from './Nettsted';
import '../styles/landing.css';

/**
 * Rammen rundt hjelpesidene når de står åpent, utenfor appen.
 *
 * Brukerveiledningen og de vanlige spørsmålene lå bak innloggingen, der bare
 * den som alt hadde konto kom til dem. Men det er der det står mest om hva
 * tjenesten faktisk gjør – «slik setter dere gjestene ved bordene» – og det er
 * slike setninger folk søker etter før de har bestemt seg. En søkemotor kommer
 * ikke forbi et innloggingsskjema, så tekstene får en adresse uten.
 *
 * Toppen og bunnen er nettstedets, ikke appens: den som kommer hit fra et søk,
 * skal se at dette er en del av vardag.no og finne veien til prisene og
 * registreringen, ikke en sidemeny til verktøy de ikke har.
 *
 * Sidene inni er de samme komponentene som i appen. Rammen sier fra om seg
 * selv gjennom `HjelperammeProvider`, og det er den som gjør at «neste
 * kapittel» og «les mer» holder seg på de åpne adressene.
 */
export function OffentligHjelp({ children }: { children: ReactNode }) {
  return (
    <HjelperammeProvider ramme="offentlig">
      <Nettstedstopp />
      <main className="offentlig-hjelp">
        <div className="container">{children}</div>
      </main>
      <Nettstedsbunn />
    </HjelperammeProvider>
  );
}
